import { getenv } from '~/settings'
export const WARN_TYPE = 'warning'

//Default Configurations
export const CONFIG_OPTION_EMPTY = '--'
export const CONFIG_OPTION_BLANK = '-'
//Processes
export const PROCESS_DISPLAY_3DP = '3D Printing'
export const PROCESS_DISPLAY_CNC = 'CNC'
export const PROCESS_DISPLAY_RTV = 'Urethane casting'
export const PROCESS_DISPLAY_IM = 'Injection molding'
export const PROCESS_DISPLAY_IM_SAMPLE = 'Injection molding samples'
export const PROCESS_DISPLAY_DC = 'Die casting'
export const PROCESSID_3DP = '3dp'
export const PROCESSID_CNC = 'cnc'
export const PROCESSID_RTV = 'rtv'
export const PROCESSID_IM = 'im'
export const PROCESSID_DC = 'diecast'
export const PROCESSID_IM_SAMPLE = 'im-sample'
export const PROCESSID_IM_TOOLING = 'im-tooling'
export const PROCESSID_IM_TOOLING_CHANGE = 'im-tooling-change'
export const PROCESSID_DC_TOOLING_CHANGE = 'die-casting-tooling-change'
export const PROCESSID_CM_TOOLING_CHANGE = 'compression-molding-tooling-change'

export const PROCESSID_SM = 'sheet'
export const PROCESSID_CM = 'cmprmold'
export const PROCESS_DC_TOOLING = 'die-casting-tooling'
export const PROCESS_DC_TOOLING_TYPE = 'diecast-tooling'
export const PROCESS_CM_TOOLING = 'compression-molding-tooling'
export const PROCESS_CM_SAMPLES = 'compression-molding-samples'
export const PROCESS_DC_SAMPLES = 'die-casting-samples'

export const TOOLING_PROCESSES = [PROCESSID_IM, PROCESSID_DC, PROCESSID_CM]

export const TOOLING_PROCESSES_IDS = [
    PROCESSID_IM_TOOLING,
    PROCESS_DC_TOOLING,
    PROCESS_CM_TOOLING,
]

export const TOOLING_PROCESSES_SAMPLES_ID = [
    PROCESS_DC_SAMPLES,
    PROCESS_CM_SAMPLES,
    PROCESSID_IM_SAMPLE,
]

export const TOOLING_CHANGE_PROCESSES_ID = [
    PROCESSID_IM_TOOLING_CHANGE,
    PROCESSID_CM_TOOLING_CHANGE,
    PROCESSID_DC_TOOLING_CHANGE,
]
// The list of processes that have additional options. Can update this list if new additionalRequirements has been added to process.
export const PROCESSES_WITH_ADDITIONAL_OPTIONS = [
    PROCESSID_CNC,
    PROCESSID_RTV,
    PROCESSID_IM,
    PROCESSID_DC,
    PROCESSID_SM,
]
// The list of processes that no limitation for attachment uploading
export const PROCESSES_WITHOUT_ATTACHMENT_LIMITATION = [
    PROCESSID_IM,
    PROCESSID_DC,
    PROCESSID_3DP,
]
// The list of processes that have threaded holes configuration
export const PROCESSES_WITH_THREADED_TAG = [PROCESSID_CNC, PROCESSID_SM]
// The list of processes that have finish (postProcesses) to add
export const PROCESSES_FOR_FINISH = [
    PROCESSID_3DP,
    PROCESSID_CNC,
    PROCESSID_DC,
    PROCESSID_SM,
]
// THe list of processes that have finish (postProcesses) need to be manual quoted(hide price and leadtime)
export const PROCESSES_FOR_MANUAL_QUOTE_FINISH = [PROCESSID_DC]
// The list of processes that allow admin to do secondaryProcess
export const PROCESSES_FOR_SECONDARY_PROCESS = [
    PROCESSID_CNC,
    PROCESSID_RTV,
    PROCESSID_3DP,
    PROCESSID_SM,
]

//Materials
export const MATERIALID_CNC_CUSTOM = 'cnc-custom'
export const MATERIALID_CNC_ALUMINUM = 'cnc-aluminum'
export const MATERIALID_RUBBER_LIKE = 'rubber-like'
export const MATERIALID_VERORIGID = 'verorigid'
export const MATERIALID_ABS_LIKE = 'rtv-pu8150'
export const MATERIALID_PLA = 'pla'
export const MATERIALID_ABS = 'abs'
export const MATERIALID_A380 = 'a380'
export const MATERIALID_RESIN_ABS = 'resin-abs'
export const MATERIALID_CM_SILICONE = 'cm-silicone'
export const MATERIALID_DC_AL380 = 'a380'
export const MATERIALID_VEROBLACK = 'veroblack'
export const MATERIALID_TRANSPARENT = 'transparent'
export const MATERIALID_VEROWHITE = 'verowhite'
export const MATERIALIDS_DISABLE_1_DAY_PRODUCTION = [
    MATERIALID_ABS,
    MATERIALID_RUBBER_LIKE,
    MATERIALID_VERORIGID,
    MATERIALID_VEROBLACK,
    MATERIALID_TRANSPARENT,
    MATERIALID_VEROWHITE,
]

//Material Categories
export const MAT_CATEGORY_ALUMINUM = 'Aluminum'
export const MAT_CATEGORY_STAINLESS = 'Stainless Steel'
export const MAT_CATEGORY_STEEL = 'Steel'
export const MAT_CATEGORY_COPPER_BRASS_BRONZE = 'Copper, Brass, Bronze'
export const MAT_CATEGORY_PLASTIC = 'Plastic'
export const MAT_CATEGORY_TITANIUM = 'Titanium'
export const MAT_CATEGORY_EXOTIC = 'Exotic Material'
export const MAT_CATEGORY_MJF = 'Multi-Jet Fusion (MJF)'
export const MAT_CATEGORY_SLS = 'Selective Laser Sintering (SLS)'
export const MAT_CATEGORY_POLYJET = 'PolyJet'
export const MAT_CATEGORY_FDM = 'Fused Deposition Modeling (FDM)'
export const MAT_CATEGORY_SLA = 'Stereolithography (SLA)'
export const MAT_CATEGORY_CUSTOM = 'Custom Materials'

//Fake Materials
export const MATERIALID_OTHER_FAKE = 'other'
export const MATERIAL_DISPLAY_OTHER_FAKE = 'Other'

//Post Processes
export const POSTPROCESSID_ANODIZING_2 = 'anodizing-2'
export const POSTPROCESSID_ANODIZING_3 = 'anodizing-3'
export const POSTPROCESSID_ANODIZING_3_PTFE = 'anodizing-3-teflon'
export const POSTPROCESSID_MASKING = 'masking'
export const POSTPROCESSID_HOLE_MASKING = 'hole-masking'

// Since this is builder configurable, it's technically a post-process
export const POST_PROCESS_ID_ADVANCED_INSPECTION = 'advanced-inspection'

// Masking post processes
export const MASKING_POST_PROCESSES = [
    POSTPROCESSID_MASKING,
    POSTPROCESSID_HOLE_MASKING,
]

// Finishes that can have masking added
export const FINISHINGS_FOR_MASKING = [
    'anodizing-2',
    'anodizing-3',
    'anodizing-3-teflon',
    'alodine',
    'black-oxide',
    'media-blasting',
    'passivation',
    'electroless-nickel-plating',
    'tumbling',
    'zinc-plating',
    'nickel-plating',
    'electropolishing',
    'powder-coating',
]

//Secondary Processes
export const SECONDARY_PROCESS_ID_CERTIFICATE_OF_COMPLIANCE =
    'certificate-of-compliance'
export const SECONDARY_PROCESS_ID_CMM_INSPECTION_REPORT =
    'cmm-inspection-report'
export const SECONDARY_PROCESS_ID_FAI = 'first-article-inspection'
export const SECONDARY_PROCESS_ID_HARDWARE_INSTALLATION =
    'hardware-installation'
export const SECONDARY_PROCESS_ID_INSPECTION = 'inspection'
export const SECONDARY_PROCESS_ID_LASER_ENGRAVING = 'laser-engraving'
export const SECONDARY_PROCESS_ID_MASKING = 'masking'
export const SECONDARY_PROCESS_ID_MATERIAL_CERTIFICATION =
    'material-certification'
export const SECONDARY_PROCESS_ID_NRE_FEE = 'nre-fee'
export const SECONDARY_PROCESS_ID_ELECTROPOLISHING = 'electropolishing'
export const SECONDARY_PROCESS_ID_ALODINE = 'alodine'

export const ALLOW_ADD_FINISH_SECONDARY_PROCESSES = new Set([
    SECONDARY_PROCESS_ID_CERTIFICATE_OF_COMPLIANCE,
    SECONDARY_PROCESS_ID_CMM_INSPECTION_REPORT,
    SECONDARY_PROCESS_ID_FAI,
    SECONDARY_PROCESS_ID_HARDWARE_INSTALLATION,
    SECONDARY_PROCESS_ID_INSPECTION,
    SECONDARY_PROCESS_ID_LASER_ENGRAVING,
    SECONDARY_PROCESS_ID_MASKING,
    SECONDARY_PROCESS_ID_MATERIAL_CERTIFICATION,
    SECONDARY_PROCESS_ID_NRE_FEE,
])

//Priorities
export const PRIORITYID_ECONOMY = 'economy'
export const PRIORITYID_RUSH = 'rush'
export const PRIORITYID_SAMEDAY = 'same-day'
export const PRIORITYID_STANDARD = 'standard'
export const PRIORITYID_FLEX = 'flex'
export const PRIORITYID_SAVER = 'saver'
export const PRIORITYID_OVERSEAS = 'overseas'
export const PRIORITYID_PREMIUM = 'premium'

// Domestic || Overseas
export const DOMESTIC = 'Domestic'
export const OVERSEAS = 'Overseas'

// These should be in order of descending cost
export const DOMESTIC_PRIORITIES = [
    PRIORITYID_SAMEDAY,
    PRIORITYID_PREMIUM,
    PRIORITYID_RUSH,
    PRIORITYID_STANDARD,
    PRIORITYID_ECONOMY,
]
export const OVERSEAS_PRIORITIES = [
    PRIORITYID_FLEX,
    PRIORITYID_SAVER,
    PRIORITYID_OVERSEAS,
]

export const DOMESTIC_PRIORITIES_SET = new Set(DOMESTIC_PRIORITIES)
export const OVERSEAS_PRIORITIES_SET = new Set(OVERSEAS_PRIORITIES)

export const PRIORITY_LABELS_3DP = {
    [PRIORITYID_SAMEDAY]: 'Same Day',
    [PRIORITYID_RUSH]: '1 Day',
    [PRIORITYID_STANDARD]: '2 Days',
}

//DFM severity
export const DFM_FAILURE = 'failure'
export const DFM_NOTICE = 'notice'
export const DFM_WARNING = 'warning'
export const DFM_COST_DRIVER = 'cost-driver'
export const DFM_NONE = 'none'

export const DFM_TAG_NAMES = {
    [DFM_FAILURE]: 'Revisions required',
    [DFM_WARNING]: 'Warning',
    [DFM_NOTICE]: 'Recommended',
    [DFM_COST_DRIVER]: 'Cost driver',
}

// Priority Restrictions
const DOMESTIC_OVERNIGHT_SHIPPING_ID = 'Overnight'
const DOMESTIC_GROUND_SHIPPING_ID = 'Ground'

export const INTERNATIONAL_SHIPPING_ID = 'overseas_1_day'
export const INTERNATIONAL_ECONOMY_SHIPPING_ID = 'overseas_economy'
export const INTERNATIONAL_PRIORITY_SHIPPING_DISPLAY_NAME_4DAYS =
    'International (4 bus. days)'

const INTERNATIONAL_ECONOMY_SHIPPING_DISPLAY_NAME = 'Int’l Economy Shipping'

export const SHIPPING_OPTION_NAME_MAPPING_UPDATED: { [key: string]: string } = {
    [INTERNATIONAL_SHIPPING_ID]:
        INTERNATIONAL_PRIORITY_SHIPPING_DISPLAY_NAME_4DAYS,
    [INTERNATIONAL_ECONOMY_SHIPPING_ID]:
        INTERNATIONAL_ECONOMY_SHIPPING_DISPLAY_NAME,
}

const INTERNATIONAL_PRIORITY_SHIPPING_DISPLAY_NAME_SHORT = 'International'
const INTERNATIONAL_ECONOMY_SHIPPING_DISPLAY_NAME_SHORT = 'Int’l Economy'

export const SHORT_SHIPPING_OPTION_NAME_MAPPING: { [key: string]: string } = {
    [INTERNATIONAL_SHIPPING_ID]:
        INTERNATIONAL_PRIORITY_SHIPPING_DISPLAY_NAME_SHORT,
    [INTERNATIONAL_ECONOMY_SHIPPING_ID]:
        INTERNATIONAL_ECONOMY_SHIPPING_DISPLAY_NAME_SHORT,
    [DOMESTIC_OVERNIGHT_SHIPPING_ID.toLowerCase()]:
        DOMESTIC_OVERNIGHT_SHIPPING_ID,
    [DOMESTIC_GROUND_SHIPPING_ID.toLowerCase()]: DOMESTIC_GROUND_SHIPPING_ID,
}
//Request Quote message
export const REQUEST_QUOTE = 'Please request a quote'

export const PRICING_UNAVAILABLE = 'Pricing unavailable'
//COV19 Message
export const DISABLED_LEAD_TIME_COV19_MSG =
    'This production speed is temporarily unavailable due to COVID-19 impact.'

export const IM_DEFAULT_TEXTURE_ID = 'spi-c3'

//Resource guide links
export const GUIDE_3DP = `${
    getenv('REGIONAL_CONFIGS')?.urls?.three_d_printing_service
}`
export const GUIDE_CNC = `${
    getenv('REGIONAL_CONFIGS')?.urls?.cnc_machining_service
}`
export const GUIDE_IM = `${
    getenv('REGIONAL_CONFIGS')?.urls?.injection_molding_service
}`
export const GUIDE_RTV = `${
    getenv('REGIONAL_CONFIGS')?.urls?.urethane_casting_service
}`
export const GUIDE_FINISH = `${
    getenv('REGIONAL_CONFIGS')?.urls?.cnc_surface_finishing_options
}`

export const DEFAULT_QTY = 1
export const DC_MIN_QTY = 100
export const IM_DC_MINIMUM_QTY = 100

export const PROCESS_NAME = 'processName'
export const ORDERED_QUANTITY = 'orderedQuantity'

// Severity messages
export const DFM_FAILURE_INFO_MSG =
    'This feedback indicates that the part cannot be manufactured by Fictiv as is currently specified  or more informantion is required to provide a quote. Please review the feedback and upload a revised part or drawing accordingly.'
export const DFM_WARNING_INFO_MSG =
    'This feedback indicates that the part has warnings that may impact the quality of your part. Please review the feedback and either modify your configuration or drawing to remove these warnings or leave them as is and accept the risks associated.'
export const DFM_COST_DRIVER_INFO_MSG =
    'This feedback indiacates that the part has requirements that are significantly increasing the price. Please review the feedback below to see what changes you can make to reduce the cost of your part.'

export const DFM_TAG_NAMES_MSGS = {
    [DFM_FAILURE]: DFM_FAILURE_INFO_MSG,
    [DFM_WARNING]: DFM_WARNING_INFO_MSG,
    [DFM_COST_DRIVER]: DFM_COST_DRIVER_INFO_MSG,
}
export const TOOLTIP_MSGS_TITLE = {
    [DFM_FAILURE]: 'Revison required',
    [DFM_WARNING]: 'Warning',
    [DFM_COST_DRIVER]: 'Cost driver',
}

export const PROCESS_NAME_MAP = {
    [PROCESSID_CM]: 'Compression Molding',
    [PROCESSID_IM]: 'Injection Molding',
    [PROCESSID_DC]: 'Die Casting',
}

export const getProcessTitle = (processId: string) => {
    let processTitle = ''

    if (processId === PROCESSID_IM_TOOLING || processId === PROCESSID_IM) {
        processTitle = PROCESS_NAME_MAP[PROCESSID_IM]
    }
    if (processId === PROCESS_DC_TOOLING || processId === PROCESSID_DC) {
        processTitle = PROCESS_NAME_MAP[PROCESSID_DC]
    }
    if (processId === PROCESS_CM_TOOLING || processId === PROCESSID_CM) {
        processTitle = PROCESS_NAME_MAP[PROCESSID_CM]
    }

    return processTitle
}

export const getProcessIdByToolingId = (toolingId: string) => {
    let toolingTitle = ''

    if (toolingId === PROCESSID_IM_TOOLING) {
        toolingTitle = PROCESSID_IM
    }
    if (toolingId === PROCESS_DC_TOOLING) {
        toolingTitle = PROCESSID_DC
    }
    if (toolingId === PROCESS_CM_TOOLING) {
        toolingTitle = PROCESSID_CM
    }

    return toolingTitle
}

export const getToolingIdByProcessId = (processId: string) => {
    let toolingId = PROCESSID_IM_TOOLING

    if (processId === PROCESSID_IM) {
        toolingId = PROCESSID_IM_TOOLING
    }
    if (processId === PROCESSID_DC) {
        toolingId = PROCESS_DC_TOOLING
    }
    if (processId === PROCESSID_CM) {
        toolingId = PROCESS_CM_TOOLING
    }

    return toolingId
}
